import { createI18n } from 'vue-i18n'
import de from '@/locales/de.json'
import en from '@/locales/en.json'

// Sprache aus localStorage laden oder Deutsch als Standard
const savedLocale = localStorage.getItem('locale') || 'de'

const i18n = createI18n({
    legacy: false,
    locale: savedLocale,
    fallbackLocale: 'de',
    messages: {
        de,
        en
    }
})

export default i18n

export function setLocale(locale) {
    i18n.global.locale.value = locale
    localStorage.setItem('locale', locale)
    document.documentElement.lang = locale
}

export function getLocale() {
    return i18n.global.locale.value
}
